import React from 'react';

interface Props {
  direction?: 'rising' | 'falling';
  height?: number;
  width?: number;
}

const TideArrow: React.FC<Props> = ({ direction, height = 20, width = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={direction === 'rising' ? { transform: 'rotate(180deg)' } : {}}
  >
    <path
      d="M9.8347 15.2519C10.2305 15.8457 11.103 15.8457 11.4988 15.2519L15.6303 9.0547C16.0733 8.39015 15.5969 7.5 14.7982 7.5L6.53526 7.5C5.73657 7.5 5.26018 8.39015 5.70321 9.0547L9.8347 15.2519Z"
      fill="#171717"
    />
  </svg>
);

export default TideArrow;
